module.exports = __webpack_public_path__ + "static/sample-24-0120d24f9595a25d9e2c98889c18ddea.png";